import React, {useEffect} from 'react'
import {connect} from 'react-redux'

import {SDKApp as PackagesSDKApp} from '@instructure/quiz-core/common/components/SDKApp/index'
import {rcsJwtRefreshFn} from '../actions/apiActions'
import {Decimal} from '@instructure/quiz-i18n/util/Decimal'
import {parseSeparators} from '@instructure/quiz-common/util/parseSeparators'

export function LtiSdkApp({
  rcsHost,
  rcsJwt,
  contextType,
  contextId,
  canvasHost,
  canvasToolId,
  userId,
  rcsJwtRefreshFn,
  timeZone,
  horizonCourse,
  horizonAccount,
  locale,
  separatorConfig,
  sdkTranslations,
  dispatch,
  ...otherProps
}) {
  // Initialize account-level decimal separator settings
  useEffect(() => {
    // eslint-disable-next-line immutable/no-mutation
    Decimal.accountSettingDelimiters =
      separatorConfig?.decimalSeparator || separatorConfig?.thousandSeparator
        ? parseSeparators(separatorConfig)
        : null
  }, [separatorConfig])

  const composeRceConfig = () => {
    return {
      rcsHost,
      rcsJwt,
      contextType,
      contextId: contextId?.toString() || null,
      canvasOrigin: canvasHost,
      canvasUserId: userId,
      rcsJwtRefreshFn,
      canvasToolId,
    }
  }

  return (
    <PackagesSDKApp
      appContainer="#root"
      locale={locale}
      timeZone={timeZone}
      translations={sdkTranslations}
      rceConfig={composeRceConfig()}
      appDispatch={dispatch}
      {...otherProps}
      horizonCourse={horizonCourse}
      horizonAccount={horizonAccount}
    />
  )
}

export function mapStateToProps({context}) {
  const {decimalSeparator, thousandSeparator} = context

  const constructSeparatorConfig = () => {
    return {
      decimalSeparator,
      thousandSeparator,
    }
  }

  return {
    timeZone: context.timeZone,
    separatorConfig: constructSeparatorConfig(),
    sdkTranslations: context.sdkTranslations,
    rcsHost: context.rcsHost,
    rcsJwt: context.rcsJwt,
    contextId: context.canvasLocalContextId,
    userId: context.userCanvasId,
    contextType: context.contextType,
    canvasHost: context.canvasHost,
    canvasToolId: context.canvasToolId,
    horizonCourse: context.horizonCourse,
    horizonAccount: context.horizonAccount,
    rldbLaunch: context.rldbLaunch,
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch,
  rcsJwtRefreshFn: (...args) => dispatch(rcsJwtRefreshFn(...args)),
})

export const SDKApp = connect(mapStateToProps, mapDispatchToProps)(LtiSdkApp)
